<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<!--page-->
<style>
  p {
    text-align: right !important;
  }
</style>
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-heading-health-family"></div>
      <div class="card-body">
        <h3>شرایط و قوانین</h3>
        <p>
          کاربر گرامی لطفاً موارد زیر را جهت استفاده بهینه از خدمات هشتگ بیمه به دقت ملاحظه فرمائید.</p>
        <div [innerHTML]="notes"></div>
        <br>
        <!--        <mat-checkbox class="custom" [formControl]="formControl">قوانین سایت را با دقت مطالعه کردم و آن را تایید می کنم-->
        <!--        </mat-checkbox>-->
        <app-checkbox-field
          [Group]="formGroup"
          [fieldLabel]="'قوانین سایت را با دقت مطالعه کردم و آن را تایید می کنم'"
          [hasFather]="false"
          [fieldName]="'accept'"
        ></app-checkbox-field>
        <br>
        <br>
        <br>
        <app-custom-button [LabelText]="'تایید و ادامه'" [Show]="true" [disabled]="!formGroup.controls.accept.value"
                           [BackButton]="true" [backUrl]="appUrl + '/details'"
                           (OnClick)="next()"></app-custom-button>
      </div>
    </div>
  </div>
</div>
